import { render, staticRenderFns } from "./CompetitionFilterLink.vue?vue&type=template&id=632f5a5a&scoped=true&"
import script from "./CompetitionFilterLink.vue?vue&type=script&lang=js&"
export * from "./CompetitionFilterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632f5a5a",
  null
  
)

export default component.exports